var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -4 40 40",
    alt: "Information Profile Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19,25.6a14.56,14.56,0,0,0,10.6,4.5A14.7,14.7,0,1,0,5.09,15.4a14.31,14.31,0,0,0,4,10C9,25.4,9.09,25.5,9.19,25.6Zm10.6,2.8a13,13,0,0,1-8.4-3.1c3.8-1.3,5.2-2.8,5.8-3.8a6,6,0,0,0,2.4.5h.3a5.26,5.26,0,0,0,2.6-.6c.5,1,1.9,2.6,5.8,3.9A13.64,13.64,0,0,1,19.79,28.4ZM15,12.6h0c.2-4.5,3.5-4.9,4.5-4.9h.3c1,0,4.3.4,4.5,4.8v.1s.4,4.2-1.5,6.3a3.87,3.87,0,0,1-3.1,1.3h0a3.87,3.87,0,0,1-3.1-1.3C14.59,16.8,15,12.6,15,12.6Zm4.8-10.3a13,13,0,0,1,9.8,21.6c-5.5-1.6-5.8-3.6-5.8-3.6h-.1L24,20c2.4-2.6,2-7.2,1.9-7.6-.2-4.7-3.5-6.4-6.2-6.4h-.2c-2.7,0-6,1.7-6.2,6.4,0,.4-.4,5,1.9,7.6.1.2.3.3.4.4-.2.5-1.1,2.1-5.7,3.4a13,13,0,0,1,9.9-21.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/Profile2.db9c4cdc.svg";
export { ForwardRef as ReactComponent };